import ArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { ReactNode } from "react";

import EmptyList from "./EmptyList";
import LoadingBackdrop from "./LoadingBackdrop";

const LimitPaginationContainer = ({
  children,
  currentPage,
  pageSize,
  itemCount,
  onPageChange,
  isLoading,
  emptyMessage,
  displayEmptyMessage = true,
}: {
  children: ReactNode;
  currentPage: number;
  pageSize: number;
  itemCount: number;
  onPageChange: (pageNumber: number) => void;
  isLoading: boolean;
  emptyMessage?: string;
  displayEmptyMessage?: boolean;
}) => {
  const numberOfPages = pageSize ? Math.ceil(itemCount / pageSize) : 1;

  return (
    <Box>
      <Box>
        {(itemCount > 0 || !displayEmptyMessage) && children}
        {itemCount === 0 && displayEmptyMessage && (
          <EmptyList message={emptyMessage} />
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {numberOfPages > 1 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              mx: 4,
              mt: 1,
            }}
          >
            <Box>
              <IconButton
                color="inherit"
                size="small"
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
              >
                <ArrowLeftIcon />
              </IconButton>
            </Box>
            <Box sx={{ mx: 1 }}>
              <Typography variant="bodyMedium">
                Page {currentPage} of {numberOfPages}
              </Typography>
            </Box>
            <Box>
              <IconButton
                color="inherit"
                size="small"
                disabled={currentPage === numberOfPages}
                onClick={() => onPageChange(currentPage + 1)}
              >
                <ArrowRightIcon />
              </IconButton>
            </Box>
          </Box>
        )}
      </Box>
      {isLoading && <LoadingBackdrop />}
    </Box>
  );
};

export default LimitPaginationContainer;
